// test2661
(2661 && 0);
